import axios from "axios";

const instance = axios.create();
instance.interceptors.response.use(
  async (response) => {
    if (response.config.url.includes("me") || response.config.url.includes("askQuestion")) return response;
    if (typeof window !== "undefined" && localStorage.getItem("tokenTime")) {
      const tokenTime = localStorage.getItem("tokenTime");
      const currentTime = new Date().getTime();
      const diff = currentTime - tokenTime;
      const diffInMinutes = Math.floor(diff / 1000 / 60);
      if (diffInMinutes < 1) return response;
    }
    if (typeof window !== "undefined" && localStorage.getItem("token") && response.config.headers.Authorization) {
      const getProfileHeader = {
        Authorization: `${localStorage.getItem("token")}`,
        "X-API-KEY": `${process.env.GATSBY_API_KEY}`,
      };
      const res = await axios({
        method: "get",
        url: `${process.env.GATSBY_API_URL}me`,
        headers: getProfileHeader,
      });
      if (res.status == 200 && res.data.newToken) {
        localStorage.setItem("token", res.data.newToken);
        localStorage.setItem("tokenTime", new Date().getTime());
        axios.defaults.headers.common["Authorization"] = `${res.data.newToken}`;
        if (
          !localStorage.getItem("buyerInspectionDate") ||
          Date.now() - localStorage.getItem("buyerInspectionDate") > 7200000
        ) {
          localStorage.setItem("buyerInspectionClosed", "notClosed");
          localStorage.setItem("buyerInspectionDate", Date.now());
          const res = await axios({
            method: "get",
            url: `${process.env.GATSBY_API_URL}buyerInspection/list`,
            headers: getProfileHeader,
          });
          if (res.status === 200) {
            if (res.data.length) {
              window.location.href = "/my-account/dashboard";
            }
          }
        }
      }
    }

    // add X-API-KEY header to all requests
    return response;
  },
  (error) => {
    if (typeof window !== "undefined") {
      if (error.response.status === 401) {
        window.localStorage.removeItem("token");
        window.localStorage.removeItem("member");
        window.localStorage.removeItem("mimictoken");
        window.localStorage.removeItem("mimicmember");

        // set redirectUrl to localStorage
        if (
          window.location.pathname != "/my-account/auction-actions/" &&
          window.location.pathname != "/members/accept-all-listings/" &&
          window.location.pathname != "/my-account/mimic-user/" &&
          window.location.pathname != "/members/seller-report-preferences" &&
          window.location.pathname != "/my-account/update-post-listings/"
        ) {
          localStorage.setItem("redirectUrl", window.location.pathname);
        }

        window.location.href = "/members/login/?session_timeout=true";
      }
    }
    return Promise.reject(error);
  },
);
export default instance;
